//******************************************************************************
//
//
//
//  #POSTS LIST
//
//
//
//******************************************************************************

var PostsList = (function() {
    var PostsList = function(element) {
        this.$body = $('body');
        this.$document = $(document);
        this.$html = $('html');
        this.$window = $(window);
        this.$component = $(element);
        this.$slider = this.$component.find('.c-posts-list__slider');
        this.swiper = null;

        this._setup();
    };

    PostsList.prototype = {
        _setup: function() {
            var _self = this;

            _self.$slider.find('.swiper-container').each(function() {
                _self.swiper = new Swiper(this, {
                    autoHeight: true,
                    loop: true,
                    navigation: {
                        nextEl: '.c-posts-list__slider-next',
                        prevEl: '.c-posts-list__slider-prev',
                    },
                    slidesPerView: 1,
                    speed: 750,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                        },
                        960: {
                            slidesPerView: 3,
                        },
                    },
                });
            });
        },
    };

    var init = function() {
        $('.c-posts-list').each(function() {
            var instance = $.data(this, 'PostsList');

            if(!instance) {
                $.data(this, 'PostsList', new PostsList(this));

                console.log('Init Posts List');
            }
        });
    };

    return {
        init: init
    };
})();